// Super Kids — Validador de Prazo (Frete Grátis)
// Regras: SP/RJ = 19 dias corridos; demais UFs = 21 dias corridos.
(function () {
  // ======= Configuração =======
  const DAYS_BY_UF = { SP: 18, RJ: 19 }; // SP/RJ
  const DEFAULT_DAYS = 21;               // Demais UFs

  // ======= Helpers =======
  const $ = (id) => document.getElementById(id);
  const $cep = $('sk-cep');
  const $btn = $('sk-calc-btn');
  const $feedback = $('sk-feedback');
  const $results = $('sk-results');
  const $dest = $('sk-dest');
  const $prazo1 = $('sk-prazo-linha1');
  const $prazo2 = $('sk-prazo-linha2');

  function addDays(date, days) {
    const d = new Date(date);
    d.setDate(d.getDate() + days);
    return d;
  }
  function formatBR(d) {
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  }
  function normalizeCep(raw) {
    const digits = (raw || '').replace(/\D/g, '').slice(0, 8);
    if (digits.length !== 8) return null;
    return digits.replace(/^(\d{5})(\d{3})$/, '$1-$2');
  }
  async function fetchViaCEP(cep) {
    const clean = cep.replace(/\D/g, '');
    const r = await fetch(`https://viacep.com.br/ws/${clean}/json/`);
    if (!r.ok) throw new Error('viacep_error');
    const data = await r.json();
    if (data.erro) throw new Error('cep_not_found');
    return { city: data.localidade, uf: data.uf };
  }
  function setFeedback(msg, isError = true) {
    $feedback.textContent = msg;
    $feedback.hidden = false;
    $feedback.style.color = isError ? '#b42318' : '#333';
  }
  function clearFeedback() {
    $feedback.textContent = '';
    $feedback.hidden = true;
  }
  function show(el) { if (el) el.hidden = false; }
  function hide(el) { if (el) el.hidden = true; }

  // Máscara de CEP
  if ($cep) {
    $cep.addEventListener('input', () => {
      let v = $cep.value.replace(/\D/g, '').slice(0, 8);
      if (v.length > 5) v = v.replace(/^(\d{5})(\d{1,3}).*/, '$1-$2');
      $cep.value = v;
    });
  }

  // Eventos
  if ($btn) $btn.addEventListener('click', onCalc);
  if ($cep) $cep.addEventListener('keydown', e => { if (e.key === 'Enter') onCalc(); });

  async function onCalc() {
    hide($results);
    const cep = normalizeCep($cep.value);
    if (!cep) return setFeedback('CEP inválido. Digite no formato 00000-000.');

    setFeedback('Consultando CEP…', false);

    try {
      const { city, uf } = await fetchViaCEP(cep);
      const ufUpper = (uf || '').toUpperCase();
      const dias = DAYS_BY_UF[ufUpper] || DEFAULT_DAYS;

      const hoje = new Date();
      const limite = addDays(hoje, dias);

      $dest.innerHTML = `Destino: <b>${city} / ${ufUpper}</b> (CEP ${cep})`;
      $prazo1.textContent = `Entrega estimada até ${formatBR(limite)}`;
      $prazo2.textContent = `(${dias} dias corridos a partir da confirmação do pedido)`;

      clearFeedback();
      show($results);
    } catch (e) {
      console.warn(e);
      setFeedback('Não foi possível consultar este CEP agora. Tente novamente em instantes.');
    }
  }
})();
